'use client';
import { useEffect } from 'react';

export default function SplashScreenHider() {
  useEffect(() => {
    const hideSplash = async () => {
      try {
        const win = window as any;
        if (win?.Capacitor?.Plugins?.SplashScreen) {
          await win.Capacitor.Plugins.SplashScreen.hide();
        }
      } catch {
        // Not a Capacitor environment
      }
    };
    hideSplash();
  }, []);

  return null;
}
